/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import React from 'react';
import RenderWhen from './When';
import {
  IIconListDataProps,
  IconListComp,
  IPaginateProps,
  Paginate,
  PlaceHolderComp,
} from './components';

export type IItemListProps = IIconListDataProps & IPaginateProps;

export const ItemListWidget = (props: IItemListProps) => {
  const { data, isLoading } = props;

  const _renderWidget = () => {
    if (isLoading) {
      return <PlaceHolderComp />;
    } else {
      return (
        <RenderWhen limit={2}>
          <RenderWhen.If isTrue={!!(Array.isArray(data) && data?.length > 0)}>
            <IconListComp {...props} />
          </RenderWhen.If>
          {/* <RenderWhen.If isTrue={!!(Array.isArray(data) && data?.length > 0)}>
            <Paginate {...props} />
          </RenderWhen.If> */}
        </RenderWhen>
      );
    }
  };
  return <>{_renderWidget()}</>;
};

ItemListWidget.defaultProps = {};
